import React from 'react';
import SEO from './SEO';
import JsonLd from './JsonLd';
import Breadcrumbs from './Breadcrumbs';
import { FIRMA, CENNIK, cenaTekst } from '../data/firma';
import { breadcrumbSchema } from '../data/schema';
import page from '../css/modules/ContentPage.module.css';
import s from '../css/modules/Landing.module.css';

/** Cennik (spec sekcja 10). Kwoty pochodza z src/data/firma.js - dopoki
 *  ktoras jest `null`, strona pokazuje "cena ustalana indywidualnie"
 *  zamiast wymyslonej liczby. */

const PATH = '/cennik/';

const CRUMBS = [
  { name: 'Strona główna', path: '/' },
  { name: 'Cennik', path: PATH },
];

const POZYCJE = [
  { ...CENNIK.diagnoza, link: '/diagnoza-sensoryczna-olsztyn/' },
  { ...CENNIK.konsultacja, link: null },
  { ...CENNIK.terapia, link: '/terapia-integracji-sensorycznej-olsztyn/' },
];

export default function Cennik() {
  return (
    <div className={page.page}>
      <SEO
        title="Cennik diagnozy i terapii SI | Sensorini Olsztyn"
        description="Cennik diagnozy sensorycznej i terapii integracji sensorycznej w gabinecie Sensorini w Olsztynie."
        pathname={PATH}
        type="website"
      />
      <JsonLd data={breadcrumbSchema(CRUMBS)} />

      <header className={page.hero}>
        <span className={`${page.blob} ${page.blobA}`} aria-hidden="true" />
        <span className={`${page.blob} ${page.blobB}`} aria-hidden="true" />
        <div className={page.heroInner}>
          <span className={page.eyebrow}>Sensorini • Olsztyn</span>
          <h1 className={page.h1}>Cennik diagnozy i terapii integracji sensorycznej</h1>
          <p className={page.lead}>
            Przejrzyste zasady rozliczeń: co wchodzi w cenę diagnozy, ile kosztują zajęcia i jak
            wygląda odwoływanie wizyt.
          </p>
        </div>
      </header>

      <Breadcrumbs items={CRUMBS} />

      <div className={page.wrap}>
        <section className={page.section}>
          <h2>Ceny usług</h2>
          <div className={s.priceTableWrap}>
            <table className={s.priceTable}>
              <thead>
                <tr>
                  <th scope="col">Usługa</th>
                  <th scope="col">Zakres</th>
                  <th scope="col">Cena</th>
                </tr>
              </thead>
              <tbody>
                {POZYCJE.map((p) => (
                  <tr key={p.nazwa}>
                    <th scope="row">{p.link ? <a href={p.link}>{p.nazwa}</a> : p.nazwa}</th>
                    <td>{p.jednostka}</td>
                    <td>{cenaTekst(p)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>

        <section className={page.section}>
          <h2>Co obejmuje cena diagnozy?</h2>
          <ul className={page.list}>
            {CENNIK.diagnoza.zawiera.map((z) => (
              <li key={z}>{z}</li>
            ))}
          </ul>
          <p style={{ marginTop: '1rem' }}>
            Szczegółowy przebieg badania opisuję na stronie{' '}
            <a href="/diagnoza-sensoryczna-olsztyn/">diagnozy integracji sensorycznej w Olsztynie</a>.
          </p>
        </section>

        <section className={page.section}>
          <h2>Konsultacja bez pełnej diagnozy</h2>
          <ul className={page.list}>
            {CENNIK.konsultacja.zawiera.map((z) => (
              <li key={z}>{z}</li>
            ))}
          </ul>
        </section>

        <section className={page.section}>
          <h2>Odwoływanie wizyt, płatności i rachunki</h2>
          <ul className={page.list}>
            <li>{CENNIK.odwolanie}</li>
            <li>{CENNIK.platnosci}</li>
            <li>{CENNIK.faktura}</li>
          </ul>
          <p className={page.callout}>
            Terapia integracji sensorycznej nie jest refundowana przez NFZ w ramach gabinetu
            prywatnego. Część placówek oświatowych przyznaje dzieciom zajęcia SI na podstawie opinii
            z poradni - warto zapytać o to w przedszkolu lub szkole dziecka.
          </p>
        </section>
      </div>

      <section className={page.ctaBand} id="final-contact">
        <div className={page.ctaInner}>
          <h2>Masz pytanie o cenę lub termin?</h2>
          <p>Zadzwoń albo napisz - odpowiem i wspólnie ustalimy plan.</p>
          <div className={page.ctaBtns}>
            <a href="/diagnoza-sensoryczna-olsztyn/" className={page.btnPrimary} data-cta="booking" data-cta-location="final">
              Umów diagnozę
            </a>
            <a href={`tel:${FIRMA.telefonE164}`} className={page.btnGhost}>
              Zadzwoń: {FIRMA.telefon}
            </a>
            <a href={`mailto:${FIRMA.email}`} className={page.btnGhost}>
              Napisz wiadomość
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
